import { useQuery } from '@tanstack/react-query'

import { GetProdutoDisponivel } from '@/http'
import { produtosKeys } from '@/utils/produtos-query-keys'

export const useProdutoDisponivel = (idExternoProduto: number) => {
  return useQuery({
    queryKey: produtosKeys.status(idExternoProduto),
    queryFn: async () => new GetProdutoDisponivel().execute(idExternoProduto).then((res) => res.data),
    enabled: false,
  })
}
